import { DEFAULT_ENHANCEMENTS, type ColourMode, type Enhancements } from '@/tools/image-engine';

export type PresetId = 'original' | 'document' | 'grey' | 'bw';

export interface Preset {
  readonly id: PresetId;
  readonly settings: Enhancements;
  readonly mode: ColourMode;
}

const NONE: Enhancements = { illumination: 0, contrast: 0, sharpness: 0, noise: 0 };

/**
 * The one-tap corrections of the «Correggi» step (#387 boards, after Adobe Scan, Lens, Drive and
 * Notes): each is a starting point for «Regolazioni avanzate».
 */
export const PRESETS: readonly Preset[] = [
  { id: 'original', settings: NONE, mode: 'colour' },
  { id: 'document', settings: DEFAULT_ENHANCEMENTS, mode: 'colour' },
  { id: 'grey', settings: DEFAULT_ENHANCEMENTS, mode: 'grey' },
  {
    id: 'bw',
    settings: { illumination: 0.7, contrast: 0.3, sharpness: 0.2, noise: 0.25 },
    mode: 'bw',
  },
];

export const DEFAULT_PRESET: PresetId = 'document';

export function presetById(id: PresetId): Preset {
  return PRESETS.find((p) => p.id === id) ?? PRESETS[1]!;
}
